module.exports = __webpack_public_path__ + "static/Lancelot PianoB-7f5ea31c217adca4a7221311467d2823.png";